<section>
    <div class="item">
        <div *ngIf="bannerDetails && bannerDetails.length>0" class="banner">
            <div *ngFor="let item of bannerDetails">
                <marquee scrolldelay="10" class="mt-3">
                    <div [innerHTML]="item.BannerText" class="" *ngIf="item.AllowBannerFlag===0"></div>
                </marquee>
            </div>
        </div>
        <div class="slider-item">
            <vg-player (onPlayerReady)="onPlayerReady($event)">
                <vg-controls style="opacity: 0;height: 0;">
                    <vg-play-pause id="pauseBtn"></vg-play-pause>
                </vg-controls>
                <vg-controls style="opacity: 0;height: 0;">
                    <vg-mute (click)="onMuteClick()"></vg-mute>
                </vg-controls>
                <!-- <video [vgMedia]="media" muted="muted" #media id="homesingleVideo" autoplay="true" preload="auto"
                    loop="true" crossorigin> -->
                    <video [vgMedia]="media" muted="muted" #media id="homesingleVideo" autoplay="true" preload="auto"
                    loop="true" > 
                   <source src="https://storage.googleapis.com/smileorchard/Video/homePage.mp4" type="video/mp4">
                  <!-- <source src="assets/videos/homePage.mp4" type="video/mp4">--> 
                </video>
                <div class="muteButton" (click)="onMuteClick()" role="button" aria-pressed="mixed" tabindex="0"
                    aria-label="mute" *ngIf="(mutedValue && mutedValue==='true')">
                    <i class="fa fa-volume-off whiteColor" aria-hidden="true"></i>
                </div>
                <div class="muteButton" (click)="onMuteClick()" role="button" tabindex="0" aria-pressed="mixed"
                    aria-label="unmute" *ngIf="(mutedValue && mutedValue==='false')">
                    <i class="fa fa-volume-up whiteColor" aria-hidden="true"></i>
                </div>
            </vg-player>
        </div>
    </div>

    <div class="secondaryBackgroundColor pt-5 pb-5" id="second-div">
        <div class="container main-container p-5 mb-5 primaryBackgroundColor about-us-text">
            <p class="text-center">We are a friendly, relaxing and interactive dental practice in Bristol, offering a
                wide
                range of affordable
                Private and NHS dentistry to our patients. With patient car park on site and lush green surroundings you
                feel at ease from the time you step in.</p>
            <p class="text-center"> Our experienced team of dental care professionals constantly work to build
                long-lasting
                relationships with
                our patients managing to achieve and maintain great oral health. We provide top of the range <a
                    class="primaryColor" routerLink="/Treatments">cosmetic
                    dental
                    treatments</a> which include <a class="primaryColor"
                    [routerLink]="['Treatment',{TreatmentType:'Braces',TreatmentID:2}]">Invisalign</a>, <a
                    class="primaryColor" [routerLink]="['Treatment',{TreatmentType:'Braces',TreatmentID:3}]">Six Month
                    Smiles</a>, <a class="primaryColor"
                    [routerLink]="['Treatment',{TreatmentType:'BoldBeautiful',TreatmentID:4}]">Teeth Whitening</a> and
                <a [routerLink]="['Smile Design']" class="primaryColor">Smile Makeovers</a>. Having
                invested
                in the most advanced technology like <a
                    [routerLink]="['Technology',{TechnologyType:'PainlessDentistry'}]" class="primaryColor">Dental
                    Lasers</a>, <a [routerLink]="['Technology',{TechnologyType:'CBCTScanner'}]"
                    class="primaryColor">CBCT scanner</a>, <a
                    [routerLink]="['Technology',{TechnologyType:'Advanced3DScanner'}]" class="primaryColor">3D
                    imaging</a> and <a href="#" class="primaryColor">Rotary Endodontics</a> at
                Smile
                Orchard, we carry out <a [routerLink]="['Treatment',{TreatmentType:'MissingTeeth',TreatmentID:1}]"
                    class="primaryColor">Dental Implants</a> and <a
                    [routerLink]="['Treatment',{TreatmentType:'General',TreatmentID:1}]" class="primaryColor">Root
                    treatments</a> very
                precisely
                and with minimal appointments.
            </p>
            <p class="text-center">For nervous patients, look no further we do <a class="primaryColor"
                    [routerLink]="['Treatment',{TreatmentType:'ConsciousSedation',TreatmentID:1}]">Conscious
                    Sedation</a>.</p>
            <p class="text-center">
                <strong> We welcome you to be a <a [routerLink]="['Membership']" class="primaryColor">privileged
                        member</a> of our customised practice plan and you are guaranteed high quality dental care at a
                    very affordable price.</strong>
            </p>
            <p class="text-center">In the interest of providing additional help to our patients, we are also proud to
                offer
                <a [routerLink]="['/Fees',{'Type':'Plans'}]" class="primaryColor">
                    payment plans
                </a>
                to help cover the cost of treatments. 
                ​
            </p>
        </div>

        <div class="container p-3 mb-5 primaryBackgroundColor">
            <h4 class="text-center mb-3 lobsterFont">DENTISTRY IS NOT EXPENSIVE. NEGLECT IS.
            </h4>
            <p class="text-center" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                <button (click)="BookAnAppointment('New Patient Consultation')" class="btn btn-primary px-4 py-2">BOOK
                    AN APPOINTMENT TODAY</button>
            </p>
        </div>

        <div class="container p-0 mb-5">
            <h2 class="text-center mb-3">Services</h2>
            <div class="odd-even-block">
                <!-- <div data-aos="fade-left" data-aos-duration="3000"
                    class="mt-4 mb-4 p-3 items primaryBackgroundColor row no-gutters justify-content-center align-items-center">
                    <div class="col-md-6 col-sm-12 pl-5">
                        <h2>My First Consultation</h2>
                        <p>What can you expect from your first consultation</p>
                        <p class="" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                            <a class="btn btn-primary px-4 py-2 text-white"
                                [routerLink]="['services',{Type:'Consultation'}]">Find Out More</a>
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img src="{{videoCdnUrl}}images/plancost.jpg" class="img-fluid w-75">
                    </div>
                </div> -->
                <div data-aos="fade-right" data-aos-duration="3000"
                    class="row no-gutters mt-4 mb-4 p-3 items primaryBackgroundColor justify-content-center align-items-center">
                    <div class="col-md-6 col-sm-12 pl-5">
                        <h2>Braces</h2>
                        <p>Find out more about the teeth straightening services we provide.</p>
                        <p class="" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                            <button (click)="BookAnAppointment('Braces')" class="btn btn-primary px-4 py-2"
                                aria-label="Book an Appointmet">BOOK AN
                                APPOINTMENT</button>
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img loading="lazy" src="{{videoCdnUrl}}images/manWithTeethBrace.jpg" alt="Braces"
                            class="img-fluid">
                    </div>
                </div>

                <div data-aos="fade-left" data-aos-duration="3000"
                    class="row no-gutters mt-4 mb-4 p-3 items primaryBackgroundColor justify-content-center align-items-center">
                    <div class="col-md-6 col-sm-12 pl-5">
                        <h2>Dental Implants</h2>
                        <p>For solutions to missing teeth, discover how dental implants could help.</p>
                        <p class="" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                            <button (click)="BookAnAppointment('Implant')" class="btn btn-primary px-4 py-2"
                                aria-label="Book an Appointmet">BOOK AN
                                APPOINTMENT</button>
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img loading="lazy" src="{{videoCdnUrl}}images/oldLadySmile.jpg" alt="Dental Implant"
                            class="img-fluid">
                    </div>
                </div>

                <div data-aos="fade-right" data-aos-duration="3000"
                    class="row no-gutters mt-4 mb-4 items p-3 primaryBackgroundColor justify-content-center align-items-center">
                    <div class="col-md-6 col-sm-12 pl-5">
                        <h2>Teeth Whitening</h2>
                        <p>Get a whiter smile using safe and effective tooth whitening treatment.</p>
                        <p class="" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                            <button (click)="BookAnAppointment('Teeth Whitening')" class="btn btn-primary px-4 py-2"
                                aria-label="Book an Appointmet">BOOK A
                                FREE CONSULTATION TODAY</button>
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img loading="lazy" src="{{videoCdnUrl}}images/ladyWithScarpSmile.jpg" alt="Teeth Whitening"
                            class="img-fluid">
                    </div>
                </div>

                <div data-aos="fade-left" data-aos-duration="3000"
                    class="row no-gutters mt-4 mb-4 p-3 items primaryBackgroundColor justify-content-center align-items-center">
                    <div class="col-md-6 col-sm-12 pl-5">
                        <h2>Facial Aesthetics</h2>
                        <p>A Non-Surgical, safe path to better skin.</p>
                        <p class="" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                            <button (click)="BookAnAppointment('Facial Aesthetics')" class="btn btn-primary px-4 py-2"
                                aria-label="Book an Appointmet">BOOK A
                                FREE CONSULTATION TODAY</button>
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img loading="lazy" src="{{videoCdnUrl}}images/facialAesthetics.png" alt="Dental Implant"
                            class="img-fluid">
                    </div>
                </div>
            </div>

            <p class="text-center">
                <button routerLink="/Treatments" aria-label="Treatment" class="btn btn-primary px-4 py-2">See All
                    Treatments
                </button>
            </p>

        </div>

        <div class="container p-5 main-container mb-5" data-aos="flip-up" data-aos-duration="5000"
            *ngIf="teamCarousel && teamCarousel.length>0">
            <h2 class="text-center mb-3">Meet Our Team</h2>

            <owl-carousel-o [options]="teamCarouselOptions" *ngIf="teamCarousel"
                class="secondaryBackgroundColor teamCarousel">
                <ng-template carouselSlide *ngFor="let items of teamCarousel" class="item">
                    <div class="col d-flex mb-sm-4 ftco-animate h-170 secondaryBackgroundColor">
                        <div class="staff primaryBackgroundColor">
                            <div [(ngModel)]="items.StaffID" ngDefaultControl (click)="viewTeamMember(items.StaffID)"
                                class="info text-center">
                                <img loading="lazy" src={{items.ImageName}} alt="staff" class="img-fluid">
                                <h3 class="mt-3">{{items.StaffName}}</h3>
                                <span class="position" [innerHtml]="items.Designation"></span>
                                <span class="position" *ngIf="items.docGDC">{{items.GDCNumber}}</span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>

        <div class="container p-0 mb-5">
            <h2 class="text-center mb-3">Patient Testimonials</h2>

            <owl-carousel-o [options]="testimonialCarouselOptions" class="secondaryBackgroundColor testimonialCarousel">
                <ng-template carouselSlide *ngFor="let items of testimonialCarousel;let i = index">
                    <div class="page-top-item testimonialBox"
                        style="background-image: url({{videoCdnUrl}}images/whiteFlowers.jpg)">
                        <div class="overlay"></div>
                        <div class="container">
                            <div class="row slider-testimonial-text align-items-center justify-content-center">
                                <div class="col-md-6 col-sm-12 p-4 m-3 ftco-animate secondaryBackgroundColor zoomInUp">
                                    <h2 class="mb-2 text-center text-black"
                                        data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                                        {{items.testimonialTitle}}
                                    </h2>
                                    <p class="text-center">{{items.testimonialBy}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>

        <div class="container p-0 mb-5">
            <div class="row no-gutters primaryBackgroundColor p-5 align-items-center justify-content-center">
                <div class="col-sm-2 text-center p-2 m-1">
                    <img loading="lazy" src="{{videoCdnUrl}}images/adi.png" alt="Association of Dental Implantology"
                        class="img-fluid">
                </div>
                <div class="col-sm-2 text-center p-2 m-1">
                    <img loading="lazy" src="{{videoCdnUrl}}images/invisalign.png" alt="Invisalign" class="img-fluid">
                </div>
                <div class="col-sm-2 text-center p-2 m-1">
                    <img loading="lazy" src="{{videoCdnUrl}}images/sixMonthsSmiles.png" alt="Six Months Smile"
                        class="img-fluid">
                </div>
                <div class="col-sm-2 text-center p-2 m-1">
                    <img loading="lazy" src="{{videoCdnUrl}}images/enlighten.png" alt="Enlighten" class="img-fluid">
                </div>
                <div class="col-sm-2 text-center p-2 m-1">
                    <img loading="lazy" src="{{videoCdnUrl}}images/dentsply.png" alt="Dentsply" class="img-fluid">
                </div>
               <!-- Need to Place With New Image  -->
                <!-- <div class="col-sm-2 text-center m-1">
                    <a href="https://britishdentalsupplies.co.uk/" target="_blank" rel="noopener">
                        <img loading="lazy" src="{{videoCdnUrl}}images/British_Dental_SuppliesLogo3.jpg"
                            alt="British Dental Supplies" class="img-fluid">
                    </a>
                </div> -->
                <div class=" text-center p-2 m-1">
                    <a href="https://futuredent.co.uk/" target="_blank" rel="noopener">
                        <img loading="lazy" src="/assets/images/FutureDent_Logo.png" alt="Future Dent"
                            class="img-fluid" width="300" height="350">
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>


<div class="modal fade" id="ModalWeAreOpenMessage" role="dialog" aria-labelledby="dialog1Title"
    aria-describedby="dialog1Desc">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center p-3 pt-4">
                    <h4 class="m-3 h4 text-center">Need some help?</h4>
                    <p class="text-center">If you leave your name, number and a convenient time, a member of our team
                        can call or text to help.</p>
                    <form [formGroup]="RequestForm">
                        <div class="form-group">
                            <input type="text" placeholder="Your Name" class="form-control" formControlName="Name"
                                required
                                [ngClass]="{'red-border-class':submitted && RequestForm.controls['Name'].errors}">
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Your Number" class="form-control" formControlName="Number"
                                required
                                [ngClass]="{'red-border-class':submitted && RequestForm.controls['Number'].errors}">
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Convenient time" class="form-control"
                                formControlName="ConvenientTime" required
                                [ngClass]="{'red-border-class':submitted && RequestForm.controls['ConvenientTime'].errors}">
                        </div>
                        <div class="form-group d-flex justify-content-between">
                            <label class="text-left mob-w-60">Would you prefer a Call or a Text message?</label>
                            <div class="row no-gutters justify-content-center align-items-center mob-w-40">
                                <span class="pr-2 switch-left-text">Call</span>
                                <label class="switch switch-primary mb-0">
                                    <input type="checkbox" id="TypeOfContact" formControlName="TypeOfContact" />
                                    <span class="slider"></span>
                                </label>
                                <span class="pl-2"> Text</span>
                            </div>
                        </div>
                        <div class="w-100 text-center">
                            <button type="button" class="btn text-white border-white btn-border-radius mr-2"
                                (click)="SendRequest()" id="btn-yes">Send</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="ModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center p-3 pt-4" id="messageText">

                </div>
                <div class="w-100 text-center">
                    <button type="button" class="btn btn-outline-primary btn-border-radius" data-dismiss="modal"
                        aria-label="Close">OK</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <div class="modal fade" id="ModalWeAreOpenMessage" role="dialog" aria-labelledby="dialog1Title" aria-describedby="dialog1Desc">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="closeWeAreOpenModal()">&times;</span>
                </button>
                <div class="text-center p-3 pt-4">
                    <img loading="lazy" src="{{videoCdnUrl}}images/protection-white.svg"  alt="covid protection" width="50" height="50">
                    <p class="m-3 h4">We’re open for patients and are here to serve you as best as we can</p>
                    <p>Dear Patients and friends,</p>
                    <p>
                        Although UK will be subject to a new lockdown as of December 26,<strong> Dental Clinics will
                            remain open.</strong>
                    </p>
                    <p>We will remain open, welcoming and treating patients from
                        <strong>Monday to Friday, between the hours of 9.00am and 5:00pm.</strong>
                    </p>

                    <p>Our Dental appointments continue to be one of the safest in the country. Here, you and your
                        <strong>Smile are always protected.</strong>
                    </p>
                </div>
                <div class="w-100 text-center">
                    <button type="button" class="btn text-white border-white btn-border-radius mr-2"
                        data-dismiss="modal" aria-label="Close" (click)="closeWeAreOpenModal()"
                        id="btn-yes">Continue</button>
                </div>
            </div>
        </div>
    </div>
</div> -->